import { ActionTypes } from '../constants/index';

export const getPostDetails = (payload: any) => ({
  type: ActionTypes.POST_DETAIL_LIST_REQUEST,
  payload,
});
